import { HeaderBarMessageHeaderInfo } from '../header-bar-message/header-bar-message.model';

export enum DeleteMessageType {
    Progress,
    Done,
    Warning,
};

/**
 * Icons that represent that message type
 */
export const DeleteTypeIcons: string[] = [
    "",                                          // Progress
    "assets/images/notification_success24.svg",  // MessageType.Done
    "assets/images/notification_warning24.svg",  // Warning
];

/**
 * Delete Message Information
 */
class MessageInfo extends HeaderBarMessageHeaderInfo {
    /**
     * Message type
     */
    messageType: DeleteMessageType = DeleteMessageType.Progress;
    /**
     * Message Text
     */
    message: string = "";
    /**
     * Message Icon
     */
    icon: string = DeleteTypeIcons[this.messageType];

    constructor() {
        super();
    }

    clear(): void {
        this.messageType = DeleteMessageType.Progress;
        this.message = "";
        super.clear();
    }
}

export class DeleteMessageBarInfo extends MessageInfo {
    constructor(message: string, type: DeleteMessageType) {
        super();
        this.message = message;
        this.messageType = type;
        this.setInitState();
        this.setState(type);
    }
    clear(): void {
        super.clear();
    }

    private setInitState() {
        this.showCaretDown = true;
        this.showCaretUp = false;
        this.showClose = true;
        this.showIcon = false;
        this.showProgress = true;
        this.showStop = true;
    }

    setState(state: DeleteMessageType) {
        this.showProgress = state == DeleteMessageType.Progress;
        this.messageType = state;
    }

    setCompleteState(hasErrors: boolean, wereAnyCanceled: boolean, completeMessage: string) {
        //
        // Place header bar into final state
        //
        this.showClose = true;
        this.showIcon = true;
        this.showCaretUp = false;
        this.showCaretDown = false;
        this.isExpanded = false;

        if (hasErrors) {
            this.setState(DeleteMessageType.Warning);
            this.showCaretUp = false;
            this.isExpanded = true;
        } else if (wereAnyCanceled) {
            this.setState(DeleteMessageType.Done);
            this.showCaretUp = false;
            this.isExpanded = true;
        } else {
            this.setState(DeleteMessageType.Done);
            this.message = completeMessage;
        }

        this.icon = DeleteTypeIcons[this.messageType];
    }
}
